import React, { useRef, useState } from 'react';
import { translate } from '@utils/i18n';
import { Popup } from '@ui/molecules/Popup';
import { Button } from '@ui';
import SprinklerSampleSubmissionForm from '../../SprinklerSampling/SprinklerSampleSubmissionForm';
import { NAMESPACE } from '../constants';
export function ActionCell({ item }) {
    var _a;
    const [open, setOpen] = useState(false);
    const [isSubmissionOpen, setIsSubmissionOpen] = useState(false);
    const anchorRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: anchorRef, variant: "default", onClick: () => setOpen((prev) => !prev) },
            React.createElement("i", { className: "fa-light fa-ellipsis" })),
        React.createElement(Popup, { anchor: anchorRef.current, show: open, onClose: () => setOpen(false), position: "bottom-right" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, { padded: true },
                    React.createElement(Button, { variant: "default", onClick: () => {
                            setIsSubmissionOpen(true);
                            setOpen(false);
                        } },
                        React.createElement("i", { className: "fa-light fa-paper-plane", "aria-hidden": "true" }),
                        translate('actions.submit_to_dyne', { namespace: NAMESPACE }))))),
        isSubmissionOpen && item.buildingId && (React.createElement("div", { className: "sprinkler-sampling-container" },
            React.createElement(SprinklerSampleSubmissionForm, { buildingId: item.buildingId, isOpen: isSubmissionOpen, onClose: () => setIsSubmissionOpen(false), initialSampleArea: [item.system, item.group].filter(Boolean).join(' - '), initialLocation: (_a = item.location) !== null && _a !== void 0 ? _a : undefined, initialHarshEnvironment: item.isHarshEnvironment })))));
}
